import React from 'react';
import { myToast } from './myToast';
import { translate } from './translateUtils';
import { validateClaimAmount } from '../pages/ClaimItems/services/claimDetailUtils';
import { checkAndAllowZeroAttach } from './attachmentControl';
import { disableInput, elementDisplay, mandatoryInput } from './elementControl';
import { isElementVisible } from './elementControl';
import { checkForDuplicates } from '../pages/ClaimItems/services/serviceOrder';
import { getObjectClaimUserInfo, getObjectRequester } from './localStorage/localStorage';
import { checkEmployeeChildrenEducation_Age, validateWHTPercentage } from '../pages/ClaimItems/services/thCustom';
import { getInvoiceFieldRule } from '../pages/ClaimItems/services/invoiceRules';
import appConfig from '../constants/config';
import { decimalRemove } from './inputValueFormat';
import { postApiAxios } from './apiClient';
import endPoint from '../constants/endPoint';
import { ValidateDOB } from '../components/FormInputComponents/PerDiemInputs';
import { format, parse, isValid, parseISO } from 'date-fns';

export const isNullOrEmpty = (value: any): boolean => value == null || value.toString() === '' || value == undefined || value == "undefined";

export const loadValidation =  (idx:number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, objCreator:any, objRequestor:any, current_module?:string, bindDDL?: { [key: string]: any | undefined }) => {
    let formIsValid = true;
    let number_of_decimal = decimalRemove();

    //Begin , saber,20251014, ensure numeric to use as ID.
    // 1) Quick, safe coercion
    const toIndex = (v: unknown): number => {
        const n = Number(v as any);
        if (Number.isFinite(n)) return n;
        const obj = v as any;
        const cand = obj?.idx ?? obj?.index ?? obj?.value ?? (Array.isArray(obj) ? obj[0] : undefined);
        const n2 = Number(cand);
        return Number.isFinite(n2) ? n2 : NaN;
    };

    const index = toIndex(idx); // ->
    if (!Number.isFinite(idx)) {
        console.warn("Invalid index:", idx);
    }
  // use the normalized index for the rest of the function
    //const i = idx;//End saber,20251014, ensure numeric to use as ID.

    const objAttachment = !isNullOrEmpty(localStorage.getItem("objAttachment")) ? JSON.parse(localStorage.getItem("objAttachment")!) : null;
    
    const resetFieldErrorState = (element: HTMLElement) => {
        element.classList.remove('err-required-input');
        element.style.border = '1px solid var(--border-color-default)';
        
        const feedback = document.querySelector<HTMLElement>(`.${element.id}-invalid-feedback`);
        if (feedback) feedback.style.display = 'none';
    };

    // Saber Amendment 20260818 [#SR-1022951]: Align KH cash advance Form requirement with legacy A01/A02 threshold behavior.
    if (inputValues[`ddlCategory${index}`]  == 46 && objCreator.country_code == "KH") {
        //Terk Amendment 20240628 [#SR-542807] : initially set optional as cash advance always mandatory
        mandatoryInput(`#ddlForm${index}`, false, "select");

        let temporaryCashAdvLimit = localStorage.getItem("TemporaryCashAdvanceLimit")? parseFloat(localStorage.getItem("TemporaryCashAdvanceLimit")!) : 0;
        let permanentCashAdvLimit = localStorage.getItem("PermanentCashAdvanceLimit")? parseFloat(localStorage.getItem("PermanentCashAdvanceLimit")!) : 0;

        //Reset required - Hazel 20251021 for SR-835634 Cash Advance Request without Pre-approval Form
        resetFieldErrorState(document.querySelector<HTMLElement>(`#ddlForm${index}`)!);
        
        const claimAmountForFormCheck = Number(inputValues[`txtClaimAmount${index}`] ?? inputValues[`txtExchangeAmount${index}`] ?? 0);

        if (inputValues[`ddlCashAdvanceType${index}`] == "A01" && claimAmountForFormCheck <= temporaryCashAdvLimit && claimAmountForFormCheck > 0 ) {
           //$('#ddlForm1').prop('required', false);//saber,20251016, Undefined $
            mandatoryInput(`#ddlForm${index}`, false, "select");
        } else if (inputValues[`ddlCashAdvanceType${index}`] == "A02" && claimAmountForFormCheck <= permanentCashAdvLimit && claimAmountForFormCheck > 0) {
            mandatoryInput(`#ddlForm${index}`, false, "select");
        } else {
            mandatoryInput(`#ddlForm${index}`, true, "select");
        }
    }

    //Begin, Saber, 20261012, CHN-23789 - [BN] Enable Permanent Cash Advance (A02)
    // BN: Form is optional. The CHF limit is controlled by the claim configuration (entitlement process), not by the UI.
    if (inputValues[`ddlCategory${index}`] == 46 && objRequestor?.country_code == "BN") {
        const bnFormElem = document.querySelector<HTMLElement>(`#ddlForm${index}`);
        if (bnFormElem) resetFieldErrorState(bnFormElem);
        mandatoryInput(`#ddlForm${index}`, false, "select");
    }
    //End, Saber, 20261012, CHN-23789


   const visibleFormGroups = Array.from(document.querySelectorAll<HTMLElement>('.form-group'))
    .filter(el => {
        const hasHiddenClasses = el.classList.contains('form-elements-hide') || el.classList.contains('d-none');
        
        // Find the closest parent with class 'form-group' and check if it has the class 'd-none'
        const parentIsHidden = el.parentElement?.classList.contains('form-elements-hide') || el.parentElement?.classList.contains('d-none');
        //const parentIsHidden = parentFormGroup && parentFormGroup !== el && (parentFormGroup.classList.contains('d-none') || parentFormGroup.classList.contains('form-elements-hide'));

        // Filter out elements that are either hidden themselves or whose parent form-group is hidden
        return !hasHiddenClasses && !parentIsHidden;
    });

    if (visibleFormGroups.length > 0) {
        visibleFormGroups.forEach((formElem) => {
            const requiredInputs = formElem.querySelectorAll<HTMLInputElement>('input[required]');
            const requiredDateInputs = formElem.querySelectorAll<HTMLTextAreaElement>('.datepicker[required]');
            const requiredTextAreas = formElem.querySelectorAll<HTMLTextAreaElement>('textarea[required]');
            const requiredSelectDDL = formElem.querySelectorAll<HTMLSelectElement>('.select-ddl-required');
            const checkboxes = formElem.querySelectorAll<HTMLInputElement>('input[type="checkbox"][required]');
            
            //Begin,saber,20251015, validate textfield inputs
           //const textfieldInputs = formElem.querySelectorAll<HTMLInputElement>('input[type="text"][required]');
              
            // validate inputs named "textfield" (only if required)
            // textfieldInputs.forEach((input) => {
            //     input.style.border = '1px solid #dee2e6';
            //     input.classList.remove('err-required-input');
            //     const invalidFeedback = document.querySelector<HTMLElement>(`.${input.id}-invalid-feedback`);
            //     if (invalidFeedback) invalidFeedback.style.display = 'none';

            //     if (input.hasAttribute('required') && isElementVisible('#' + input.id) && isNullOrEmpty(inputValues[input.id])) {
            //         formIsValid = false;
            //         input.style.border = '1px solid red';
            //         input.classList.add('err-required-input');
            //         if (invalidFeedback) invalidFeedback.style.display = 'block';
            //     }
            // }); 
            //End,saber,20251015, validate textfield inputs

            requiredInputs.forEach((input) => {
                input.style.border = '1px solid #dee2e6';
                input.classList.remove("err-required-input");
                const invalidFeedback = document.querySelector<HTMLElement>(`.${input.id}-invalid-feedback`);
                if (invalidFeedback) {

                    invalidFeedback.style.display = 'none'; // hide the invalid feedback element
                }

                if (isNullOrEmpty(inputValues[input.id]) && isElementVisible('#'+ input.id)) {

                    formIsValid = false;

                    input.style.border = '1px solid red';
                    input.classList.add("err-required-input");
                    if (invalidFeedback) {

                        invalidFeedback.style.display = 'block'; // Show the invalid feedback element
                    }
                }
                
            });

            requiredTextAreas.forEach((textarea) => {
                textarea.style.border = '1px solid #dee2e6';
                textarea.classList.remove("err-required-input");
                const invalidFeedback = document.querySelector<HTMLElement>(`.${textarea.id}-invalid-feedback`);
                if (invalidFeedback) {

                    invalidFeedback.style.display = 'none'; // hide the invalid feedback element
                }
                if (isNullOrEmpty(inputValues[textarea.id]) && isElementVisible('#'+ textarea.id)) {

                    formIsValid = false;
                    textarea.style.border = '1px solid red';
                    textarea.classList.add("err-required-input");
                    if (invalidFeedback) {

                        invalidFeedback.style.display = 'block'; // Show the invalid feedback element
                    }
                }
            });

            requiredSelectDDL.forEach((select) => {
                select.style.border = '1px solid #dee2e6';
                select.classList.remove("err-required-input");
                const invalidFeedback = document.querySelector<HTMLElement>(`.${select.id}-invalid-feedback`);
                if (invalidFeedback) {

                    invalidFeedback.style.display = 'none'; // hide the invalid feedback element
                }
                if (isNullOrEmpty(inputValues[select.id]) && !select?.classList.contains('d-none') 
                     && isElementVisible('#'+ select.id)) {

                    formIsValid = false;
                    select.style.border = '1px solid red';
                    select.classList.add("err-required-input");
                    if (invalidFeedback) {
                        invalidFeedback.style.display = 'block'; // Show the invalid feedback element
                    }
                }
            });

            checkboxes.forEach((input) => {
                input.style.border = '1px solid #dee2e6';
                input.classList.remove("err-required-input");
                const invalidFeedback = document.querySelector<HTMLElement>(`.${input.id}-invalid-feedback`);
                if (invalidFeedback) {

                    invalidFeedback.style.display = 'none'; // hide the invalid feedback element
                }

                if ((isNullOrEmpty(inputValues[input.id]) || inputValues[input.id] == "0") && !input?.classList.contains('d-none') 
                     && isElementVisible('#'+ input.id)) {

                    formIsValid = false;
                    input.style.border = '1px solid red';
                    input.classList.add("err-required-input");
                    if (invalidFeedback) {

                        invalidFeedback.style.display = 'block'; // Show the invalid feedback element
                    }
                }

            });


        });

    }

    //resign date checking
    if (objRequestor.lasT_WORKING_DATE) {

        let lastWorkingDate = new Date(2100, 0, 1);
        let receiptDate = new Date(2100, 0, 1);

        let oneMonthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );

        oneMonthAgo.setHours(0, 0, 0, 0);

        let today = new Date();
        today = oneMonthAgo;

        let todayString = "";
        let todayDate = new Date();

        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();

        todayDate = new Date(yyyy + '-' + mm + '-' + dd);

        lastWorkingDate = objRequestor.lasT_WORKING_DATE;
        receiptDate = inputValues[`txtDate${index}`];

        //block cash claim by comparing last working date and current date. In case last date is updated earlier than exit date.
        if ((todayDate > lastWorkingDate) && (inputValues[`txtCreditCard${index}`] == "0")) {
            myToast.warning(translate("Invalid access due to last working date (30 days after last working date)."));
            formIsValid = false;

            // return formIsValid;
        }

        //if it is cash/credit card transaction and staff has resigned, the receipt date cannot be later than resign date.
        if ((receiptDate > lastWorkingDate)) {
            myToast.warning(translate("Receipt date cannot be later than last working date."));
            formIsValid = false;

            // return formIsValid;
        }

    }

    //Accomodation Allowance
    if (inputValues[`ddlCategory${index}`] == 41) {
        if (!((objRequestor.prism_global_bu_code == 'HEC' && (objRequestor.ee_subgroup_id == 'B3' || objRequestor.ee_subgroup_id == 'B4' || objRequestor.ee_subgroup_id == 'B5' || objRequestor.ee_subgroup_id == 'B6' || objRequestor.ee_subgroup_id == 'B7' || objRequestor.ee_subgroup_id == 'B8' || objRequestor.ee_subgroup_id == 'B9' || objRequestor.ee_subgroup_id == 'C4' || objRequestor.ee_subgroup_id == 'C5' || objRequestor.ee_subgroup_id == 'C6')) || objRequestor.prism_global_bu_code == 'CG')) {
            myToast.warning(translate("You are not entitled for this category."));
            formIsValid = false;
            // return formIsValid;
        }
    }

    //20cc
    // for (let iCounter = 1; iCounter <= 20; iCounter++) {
    //     if (!isNullOrEmpty(inputValues[`ddlCC${iCounter}_${index}`])) {
    //         if (bindDDL && bindDDL?.['costCenterDDL'].length) {
    //             if (!isNullOrEmpty(inputValues[`ddlCC${iCounter}_${index}`])) {
    //                 let obj = $('#costCenterMasterList').find("option[value='" + $("#ddlCC" + iCounter + "_" + id_n).val() + "']");

    //                 if (obj != null && obj.length > 0) {
    //                     $("#ddlCC" + iCounter + "_" + id_n).removeClass('is-invalid');
    //                 }
    //                 else {

    //                     $("#ddlCC" + iCounter + "_" + id_n).addClass('is-invalid');

    //                     formIsValid = false;
    //                 }
    //             }
    //             else {
    //                 //cost center not filled in , check cost center percent
    //                 if ($("#txtCCPercent" + iCounter + "_" + id_n).val().length == 0) {
    //                     $("#ddlCC" + iCounter + "_" + id_n).removeClass('is-invalid');
    //                 }
    //             }
    //         }
    //     }
    // }

    if (document.querySelector<HTMLElement>("#txtRecoverable")) {
    //if ($('#lstRecoverableOthers' + id_n).length) {
        //if ($('#lstRecoverableOthers' + id_n + ' option').length > 0) {
            if (!isNullOrEmpty(inputValues[`txtRecoverable${index}`])) {
                let obj = bindDDL?.[`recoverableDDL`]?.filter((option: any) => option.value == inputValues[`txtClientVendorCode${index}`]);

                    if (obj != null && obj.length > 0) {
                        elementDisplay(`.txtRecoverable${index}-invalid-feedback`, false, "div");
                    }
                    else {
                        elementDisplay(`.txtRecoverable${index}-invalid-feedback`, true, "div");
                        formIsValid = false;
                        // return formIsValid;
                    }
            }
        //}
    //}
    }

    
//Begin,Saber,20251124,SR-858488 Vendor Code validation update  

  // Vendor Code validation - required when either Recoverable is filled OR Claimable is checked
  //Begin,Saber SR-885133 ,20260113, Vendor Code validation update
{
  const vendorId = `txtClientVendorCode${index}`;
  const recoverableId = `txtRecoverable${index}`;
  const claimableId = `chkClaimable${index}`;
  const feedbackSel = `.${vendorId}-invalid-feedback`;
  const recoverableFeedbackSel = `.${recoverableId}-invalid-feedback`;
  
  const vendorEl = document.querySelector<HTMLInputElement>(`#${vendorId}`);
  const rawVendor = (inputValues[vendorId] ?? "").toString().trim();
  const recoverableVal = inputValues[recoverableId];
  const isClaimable = inputValues[claimableId] === "1" || inputValues[claimableId] === 1;
  
  const hasRecoverable = !isNullOrEmpty(recoverableVal);
  const hasVendor = !isNullOrEmpty(rawVendor);
  const vendorOptions = Array.isArray(bindDDL?.apVendorCodeDDL) ? bindDDL!.apVendorCodeDDL : [];
  
  // Check if vendor field is visible
  if (!isElementVisible(`#${vendorId}`)) {
    elementDisplay(feedbackSel, false, "div");
    elementDisplay(recoverableFeedbackSel, false, "div");
  } else {
    const setInvalid = (msg: string) => {
      myToast.error(translate(msg));
      if (vendorEl) {
        vendorEl.style.border = "1px solid red";
        vendorEl.classList.add("err-required-input");
      }
      elementDisplay(feedbackSel, true, "div");
      elementDisplay(recoverableFeedbackSel, true, "div");
      formIsValid = false;
    };

    const clearInvalid = () => {
      if (vendorEl) {
        vendorEl.style.border = "1px solid var(--border-color-default)";
        vendorEl.classList.remove("err-required-input");
      }
      elementDisplay(feedbackSel, false, "div");
      elementDisplay(recoverableFeedbackSel, false, "div");
    };

    // Vendor code required when either Recoverable filled OR Claimable checked
    const requiresVendor = hasRecoverable || isClaimable;
    
    if (!requiresVendor) {
      // Neither recoverable nor claimable -> vendor code ignored (optional)
      clearInvalid();
    } else {
      // Recoverable or Claimable set -> vendor code becomes required
      if (!hasVendor) {
        const triggerMsg = hasRecoverable && isClaimable 
          ? "Client Vendor Code is required when recoverable is entered and claimable is checked."
          : hasRecoverable
          ? "Client Vendor Code is required when recoverable is entered."
          : "Client Vendor Code is required when claimable is checked.";
        setInvalid(triggerMsg);
      } else if (!vendorOptions.length) {
        setInvalid("Client Vendor Code list not loaded. Please retry.");
      } else {
        const valid = vendorOptions.some(o => o.value == rawVendor);
        if (!valid) {
          setInvalid("Please enter valid Client Vendor Code.");
        } else {
          clearInvalid();
        }
      }
    }
  }
}

    // if (!isNullOrEmpty(inputValues[`txtRecoverable${index}`])) {
    //     if (bindDDL?.[`apVendorCodeDDL`]?.length > 0) {
    //         if (!isNullOrEmpty(inputValues[`txtClientVendorCode${index}`])) {
    //             // let obj = $('#AnPVendorMasterList').find("option[value='" + $("#txtClientVendorCode" + id_n).val() + "']");
    //             let obj = bindDDL?.[`apVendorCodeDDL`]?.filter((option: any) => option.value == inputValues[`txtClientVendorCode${index}`]);
    //             if (obj != null && obj.length > 0) {
    //                 elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, false, "div");
    //             }
    //             else {
    //                 myToast.error(translate("Valid Client Vendor Code is required."));
    //                 elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, true, "div");
    //                 formIsValid = false;
    //                 // return formIsValid;
    //             }
    //         }
    //     } else if (!isNullOrEmpty(inputValues[`txtClientVendorCode${index}`])) {
    //         myToast.error(translate("Please enter valid Client Vendor Code."));
    //         elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, true, "div");
    //         formIsValid = false;
    //         // return formIsValid;
    //     }
    // }

    // if (!isNullOrEmpty(inputValues[`txtClientVendorCode${index}`])) {
    //     if (bindDDL?.[`apVendorCodeDDL`]?.length) {
    //         if (bindDDL?.[`apVendorCodeDDL`]?.length > 0) {
    //             if (!isNullOrEmpty(inputValues[`txtClientVendorCode${index}`])) {
    //                 // let obj = $('#AnPVendorMasterList').find("option[value='" + $("#txtClientVendorCode" + id_n).val() + "']");
    //                 let obj = bindDDL?.[`apVendorCodeDDL`]?.filter((option: any) => option.value == inputValues[`txtClientVendorCode${index}`]);

    //                 if (obj != null && obj.length > 0) {
    //                     elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, false, "div");
    //                 }
    //                 else {
    //                     elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, true, "div");
    //                     formIsValid = false;
    //                     // return formIsValid;
    //                 }
    //             }
    //         } else if (!isNullOrEmpty(inputValues[`txtClientVendorCode${index}`])) {
    //             elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, true, "div");
    //             formIsValid = false;
    //             // return formIsValid;
    //         }
    //     } else if (!isNullOrEmpty(inputValues[`txtClientVendorCode${index}`])) {
    //         elementDisplay(`.txtClientVendorCode${index}-invalid-feedback`, true, "div");
    //         formIsValid = false;
    //         // return formIsValid;
    //     }
    // }
  
      //End,Saber SR-885133 ,20260113, Vendor Code validation update

  //End,Saber,20251124,SR-858488 Vendor Code validation update  

      if (!isNullOrEmpty(inputValues[`ddlForm${index}`]) && bindDDL?.[`formDDL`]?.length > 0) {
        let cur_form_list = bindDDL?.[`formDDL`];
        //Begin,Saber,20261009,INC-1050242 - Use form list index (no longer shadows claim row index) and skip check when form local amount is NULL
        const formListIndex = cur_form_list.findIndex((p: any) => p.value == inputValues[`ddlForm${index}`]);
        if (formListIndex > -1) {
            const formAmount = cur_form_list[formListIndex].amount;
            if (!isNullOrEmpty(formAmount) && +(inputValues[`txtExchangeAmount${index}`]) > +formAmount) {
                myToast.warning(translate("Form amount is insufficient."));
                formIsValid = false;
                // return formIsValid;
            }
        }
        //End,Saber,20261009,INC-1050242
    }
    
    //Begin,Saber,20261021,INC-1059599 - Require cost element when no Exceedra code, matching legacy
    const noExceedraCode = isNullOrEmpty(inputValues[`ddlExceedraNoCode${index}`])
        || inputValues[`ddlExceedraNoCode${index}`]?.toString() == "1";
    const costElementRequired = noExceedraCode
        && inputValues[`ddlCategory${index}`]?.toString() != "3"
        && isElementVisible(`#APCostElement${index}`);

    if (costElementRequired && isNullOrEmpty(inputValues[`ddlCostElement${index}`])) {
        const costElementFeedback = document.querySelector<HTMLElement>(`.ddlCostElement${index}-invalid-feedback`);
        if (costElementFeedback) costElementFeedback.style.display = "block";
        document.querySelector<HTMLElement>(`#ddlCostElement${index}`)?.classList.add("err-required-input");
        formIsValid = false;
    } else if (!isNullOrEmpty(inputValues[`ddlCostElement${index}`])) {
        const costElementFeedback = document.querySelector<HTMLElement>(`.ddlCostElement${index}-invalid-feedback`);
        if (costElementFeedback) costElementFeedback.style.display = "none";
        document.querySelector<HTMLElement>(`#ddlCostElement${index}`)?.classList.remove("err-required-input");
        if (bindDDL?.[`apCostElementDDL`]?.length) {
            if (bindDDL?.[`apCostElementDDL`]?.length > 0) {
                if (!isNullOrEmpty(inputValues[`ddlCostElement${index}`])) {
                    let obj = bindDDL?.[`apCostElementDDL`]?.filter((option: any) => option.value == inputValues[`ddlCostElement${index}`]);

                    if (obj != null && obj.length > 0) {
                        elementDisplay(`.ddlCostElement${index}-invalid-feedback`, false, "div");
                    }
                    else {

                        elementDisplay(`.ddlCostElement${index}-invalid-feedback`, true, "div");
                        formIsValid = false;
                        // return formIsValid;
                    }
                }
            }
        }
    }
    //End,Saber,20261021,INC-1059599

    // MY98 Tech Allowance check remark is not empty
    if (inputValues[`ddlCategory${index}`] == 49) {
        let textareamsg = "";
        textareamsg = !isNullOrEmpty(inputValues[`txtRemarks${index}`]) ? inputValues[`txtRemarks${index}`].toString().trim() : "";
    
        if (isNullOrEmpty(inputValues[`txtRemarks${index}`])) {
            myToast.warning(translate("Please key in remarks."));
            formIsValid = false;
            // return formIsValid;
        }
    }

    if (objCreator.country_code == "JP" && inputValues[`ddlCategory${index}`] == 17) {
        if (inputValues[`ddlCostElement${index}`] == "AP01002") {
            elementDisplay(`.ddlCostElement${index}-invalid-feedback`, false, "div");
            formIsValid = true;
        }
    }

    if (document.querySelector(`#divAP1_${index}`) !== null) {
        if (!isNullOrEmpty(inputValues[`txtAPeventPercent1_${index}`]) || isElementVisible(`#txtAPeventPercent1_${index}`) && document.querySelector<HTMLInputElement>(`#txtAPeventPercent1_${index}`)?.disabled == false) {
            if (bindDDL?.[`apEventDDL`]?.length) {
                if (bindDDL?.[`apEventDDL`]?.length > 0) {
                    let total_percentage = 0.00;

                    for (let a = 1; a <= 15; a++) {
                        if (isElementVisible(`#divAP${a}_${index}`)) {
                            total_percentage += parseFloat(inputValues[`txtAPeventPercent${a}_${index}`]?.toString() ?? "0");

                            if (parseFloat(inputValues[`txtAPeventPercent${a}_${index}`]?.toString() ?? "0") < 0) {
                                myToast.warning(translate("Project Code percentage cannot have negative."));
                                formIsValid = false;
                                // return formIsValid;
                            }

                        } else {
                            break;
                        }
                    }

                    if (inputValues[`ddlCategory${index}`] == 3 && total_percentage != 100) {
                        if (inputValues[`ddlNonLocalInvolve${index}`] == 1) {
                            myToast.warning(translate("Project Code percentage does not equal 100."));
                            formIsValid = false;
                            // return formIsValid;
                        }
                    } else if ((inputValues[`ddlCategory${index}`] == 17 || inputValues[`ddlCategory${index}`]  == 45) && total_percentage != 100) {
                        if (inputValues[`chkExceedraNoCode${index}`] == 0) {
                            myToast.warning(translate("Project Code percentage does not equal 100."));
                            formIsValid = false;
                            // return formIsValid;
                        }
                    } else if (total_percentage != 100) {
                        myToast.warning(translate("Project Code percentage does not equal 100."));
                        formIsValid = false;
                        // return formIsValid;
                    }

                    //Duplication checking
                    let APlist = [];
                    for (let a = 1; a <= 15; a++) {
                        if (isElementVisible(`#divAP${a}_${index}`)) {
                            APlist.push(inputValues[`txtAPCeventID${a}_${index}`]);
                        } else {
                            break;
                        }
                    }
                    if (checkForDuplicates(APlist)) {
                        myToast.warning(translate("Project Code has duplicates."));
                        formIsValid = false;
                        // return formIsValid;
                    }


                    for (let a = 1; a <= 15; a++) {
                        if (inputValues[`txtAPCeventID${a}_${index}`]) {
                            if (bindDDL?.[`apEventDDL`].length) {
                                if (bindDDL?.[`apEventDDL`]?.length > 0) {
                                    if (isElementVisible(`txtAPCeventID${a}_${index}`) && !isNullOrEmpty(`txtAPCeventID${a}_${index}`)) {
                                        let obj = bindDDL?.[`apEventDDL`]?.filter((option: any) => option.value == inputValues[`txtAPCeventID${a}_${index}`]);

                                        if (obj != null && obj.length > 0) {
                                            elementDisplay(`.txtAPCeventID${a}_${index}-invalid-feedback`, false, "div");
                                        }
                                        else {
                                            myToast.warning(translate("Event Code entered is invalid."));
                                            elementDisplay(`.txtAPCeventID${a}_${index}-invalid-feedback`, true, "div");
                                            formIsValid = false;
                                            // return formIsValid;
                                        }
                                    }
                                }
                            }
                        }
                    }

                } 
                // else {
                //     myToast.warning(translate("Event Code entered is invalid."));
                //     elementDisplay(`.txtAPCeventID${a}_${index}-invalid-feedback`, true, "div");
                //     formIsValid = false;
                //     return formIsValid;
                // }
            }
        }
    }

     //Internal Order Code validation checking
    if (!isNullOrEmpty(inputValues[`ddlinternal_order${index}`])) {
        if (bindDDL?.[`internalOrderDDL`]?.length) {
            if (bindDDL?.[`internalOrderDDL`]?.length > 0) {
                if (!isNullOrEmpty(inputValues[`ddlinternal_order${index}`])) {
                    let obj = bindDDL?.[`internalOrderDDL`]?.filter((option: any) => option.value == inputValues[`ddlinternal_order${index}`]);

                    if (obj != null && obj.length > 0) {
                        elementDisplay(`.ddlinternal_order${index}-invalid-feedback`, false, "div");
                    }
                    //else if (objRequestor.company_code.startsWith('PT') && $("#ddlinternal_order" + id_n).val()!='') {

                    //    $("#ddlinternal_order" + id_n).removeClass('is-invalid');


                    //}
                    else if (document.querySelector<HTMLSelectElement>(`#ddlinternal_order${index}`)?.classList.contains(`select-ddl-required`)) {
                        elementDisplay(`.ddlinternal_order${index}-invalid-feedback`, true, "div");
                        formIsValid = false;
                        // return formIsValid;
                    }
                }
            } else if (document.querySelector<HTMLSelectElement>(`#ddlinternal_order${index}`)?.classList.contains(`select-ddl-required`)) {
                elementDisplay(`.ddlinternal_order${index}-invalid-feedback`, true, "div");
                formIsValid = false;
                // return formIsValid;
            }
        }
    }

    if (inputValues[`ddlCategory${index}`] == 47) {
        let CashCardLimit = !isNullOrEmpty(localStorage.getItem("CashCardLimit")) ? localStorage.getItem("CashCardLimit") : "0";
        let limit_amount = Math.abs(inputValues[`txtNumberOfCashCard${index}`]) * parseFloat(CashCardLimit?.toString() ?? "0");

        if (Math.abs(inputValues[`txtExchangeAmount${index}`]) > limit_amount) {
            myToast.warning(translate("Cash limit for each card is : ") + CashCardLimit);
            if (objCreator.country_code == "TH") {
                myToast.warning(translate("Cash limit for each card is : ") + CashCardLimit + " CHF. ");
            } else {
                myToast.warning(translate("Cash limit for each card is : ") + CashCardLimit);
            }

            formIsValid = false;
            // return formIsValid;
        }
    }

    if (current_module == "ExpReport" && objAttachment.iS_CC == "1") {

        if (inputValues[`ddlCategory${index}`] == 16 || inputValues[`ddlCategory${index}`] == 51) {  //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.

            myToast.warning(translate("Not applicable for corporate credit card transactions."));
            formIsValid = false;
            // return formIsValid;
        }
        else if (inputValues[`ddlCategory${index}`]== 4 && inputValues[`ddlTransportType${index}`] == 2 && objRequestor.company_code != 'NZ94' && objRequestor.company_code != 'NZ95'){
            myToast.warning(translate("Not applicable for corporate credit card transactions."));
            formIsValid = false;
            // return formIsValid;
        }
        handleInputChange(`hidden_Init_claim_Amount${index}`, inputValues[`txtClaimAmount${index}`]);
        
    }


     //error message checking for tax column

    //Null value checking for text box input tax rate
    if (!isNullOrEmpty(inputValues[`ddlTaxCode1_${index}`])) {
        if (isNullOrEmpty(inputValues[`txtcoderate1_${index}`])) {
            myToast.warning(translate("Please key in some number value in the tax column one. Zero is acceptable when there is not tax."));
            formIsValid = false;
            // return formIsValid;
        }

    }
    if (!isNullOrEmpty(inputValues[`ddlTaxCode2_${index}`])) {
        if (isNullOrEmpty(inputValues[`txtcoderate2_${index}`])) {
            myToast.warning(translate("Please key in some number value in the tax column two. Zero is acceptable when there is not tax."));
            formIsValid = false;
            // return formIsValid;
        }

    }
    if (!isNullOrEmpty(inputValues[`ddlTaxCode3_${index}`])) {
        if (isNullOrEmpty(inputValues[`txtcoderate3_${index}`])) {
            myToast.warning(translate("Please key in some number value in the tax column three. Zero is acceptable when there is not tax."));
            formIsValid = false;
            // return formIsValid;
        }

    }
    if (!isNullOrEmpty(inputValues[`ddlTaxCode4_${index}`])) {
        if (isNullOrEmpty(inputValues[`txtcoderate4_${index}`])) {
            myToast.warning(translate("Please key in some number value in the tax column four. Zero is acceptable when there is not tax."));
            formIsValid = false;
            // return formIsValid;

        }

    }


    //Based on taxcompulsory control, force user to enter at least one tax amount value which is greater than zero value
    let taxcomplusorychk = localStorage.getItem("TaxCompulsory");
    if(!isNullOrEmpty(inputValues[`ddlTaxCode1_${index}`])) { //Check any tax column exisit in user interface or not
        if (taxcomplusorychk == 'Yes') {
            let validtaxamt = [];

            let numberoftaxcol = 1;

            //This if condition to check is there more than one tax column with value display in the interface
            if (!isNullOrEmpty(inputValues[`ddlTaxCode2_${index}`])) {
                numberoftaxcol = 2;
            }

            if (Math.abs(inputValues[`txtcoderate1_${index}`]) > 0) {
                validtaxamt.push(1);
            }

            if (Math.abs(inputValues[`txtcoderate2_${index}`]) > 0) {
                validtaxamt.push(1);
            }

            if (Math.abs(inputValues[`txtcoderate3_${index}`]) > 0) {
                validtaxamt.push(1);
            }

            if (Math.abs(inputValues[`txtcoderate4_${index}`]) > 0) {
                validtaxamt.push(1);
            }

            if (validtaxamt.length <= 0) {
                if (numberoftaxcol == 1) {
                    myToast.warning(translate("Tax amount must not be 0.00."));
                    formIsValid = false;
                } else if (numberoftaxcol == 2) {
                    myToast.warning(translate("Tax amount must not be 0.00."));
                    formIsValid = false;
                }
            }
        }
    }

    //Only non Corporate credit will check this error message
    //Tax amount cannot exceed tax percentage calculated value

    let currentuserinfo = objRequestor;

    if (currentuserinfo.country_code != 'TW') { //TW do not checking Tax amount error message
        for (let a = 1; a <= 4; a++) {
            if (inputValues[`ddlTaxCode1${a}_${index}`]) { //Check Tax is it available
                if (inputValues[`txtcoderate${a}_${index}`] > 0) {

                    let tax_amount = 0;
                    let taxrateval = ((parseInt(inputValues[`ddlTaxCode1${a}_${index}`]) + 1) / 100) + 1;
                    tax_amount = parseFloat((inputValues[`txtClaimAmount${index}`] ?? "0").toString()) - (parseFloat((inputValues[`txtClaimAmount${index}`] ?? "0").toString()) / taxrateval);


                    //bind the amount user input in CN txtcoderate to correct txtcoderate for validation
                    if (currentuserinfo.country_code == 'CN') {
                        if (inputValues[`ddlTaxCodeCN_${index}_text`]  == inputValues[`ddlTaxCode${a}_${index}`]) {
                            handleInputChange(`txtcoderate${a}_${index}`, inputValues[`txtcoderateCN_${index}`]);
                        }
                    }

                    if (inputValues[`txtcoderate${a}_${index}`] > tax_amount) {
                        myToast.warning(translate(`Tax amount ${a} cannot exceed calculated tax percentage amount.`));
                        formIsValid = false;

                    }
                }
            } else {
                break;
            }
        }
    }

     //Tax amount value cannot greater than Total input amount
    let total_temp_tax_amount = 0
    for (let a = 1; a <= 4; a++) {
        if (!isNullOrEmpty(inputValues[`ddlTaxCode${a}_${index}`]) && inputValues[`hideTaxChk${a}_${index}`] == 0) { //Check Tax is it available
            total_temp_tax_amount = total_temp_tax_amount + parseFloat(inputValues[`txtcoderate${a}_${index}`]?.toString() ?? "0")
        } else {
            break;
        }
    }

    if (total_temp_tax_amount> 0) {
        if (Math.abs(inputValues[`txtExchangeAmount${index}`]) <= Math.abs(total_temp_tax_amount)) {
            myToast.warning(translate(`Tax amount cannot exceed or equal to invoice/receipt amount`));
            formIsValid = false;
        }
    }

    // formIsValid = false;
    //Only one tax column can be submited
    let number_of_tax_input = 0
    for (let a = 1; a <= 4; a++) {
        if (!isNullOrEmpty(inputValues[`ddlTaxCode${a}_${index}`])) { //Check Tax is it available
            if (!isNullOrEmpty(inputValues[`txtcoderate${a}_${index}`]) && inputValues[`txtcoderate${a}_${index}`] > 0) {
                number_of_tax_input++;
            }
        } else {
            break;
        }
    }

    if (number_of_tax_input >= 2) {
        myToast.warning(translate(`Only one tax column can be submitted`));
        formIsValid = false;
    }

    // //error message checking for tax column

    // //Error message checking for per diem calculation

    //Control Checking for country who can access per diem calculation function
    let temprequestor = getObjectRequester();
    let objClaimUserInfo = getObjectClaimUserInfo();
    let final_control_checking_user;

    if (!isNullOrEmpty(objClaimUserInfo)) {
        final_control_checking_user = objClaimUserInfo;
    } else if (!isNullOrEmpty(temprequestor)) {
        final_control_checking_user = temprequestor;
    }

    let country_per_diem_control = appConfig.PerDiemControlCountry.split(",")

    if (country_per_diem_control.includes(final_control_checking_user?.country_code ?? "")) {

        if (inputValues[`ddlCategory${index}`] == 16 || inputValues[`ddlCategory${index}`] == 51) { //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic

            let num_per_diem_col = appConfig.PerDiemColumn;
            let num_of_days_allocated = 0;
            for (let a = 1; a <= num_per_diem_col; a++) {
                if (document.querySelector<HTMLSelectElement>(`#txtPerDiem_NumberofDaysSPR${a}_${index}`)?.classList.contains("needValue")) {
                    num_of_days_allocated = num_of_days_allocated + parseInt(inputValues[`txtPerDiem_NumberofDaysSPR${a}_${index}`]?.toString() ?? "0", 10);
                } else {
                    break; //Break when there is no value is found
                }
            }

            let start_date = new Date()
            let end_date = new Date()
            let num_of_days = 0
            let negative_date = 0
            let same_date = 0
            
            
            //Begin, Saber, 20260522, CHN-21544 - Per diem date validation hardening
            //Begin, Saber, 20260522, CHN-21544 - Per diem date validation hardening
            // Safely format various date inputs (Date or ISO string) to MM/dd/yyyy
            // to avoid RangeError when per diem dates are blank or invalid.
            // to avoid RangeError when per diem dates are blank or invalid.
            const toMMDDYYYY = (val: unknown): string => {
                if (!val) return "";
                let d: Date;

                if (val instanceof Date) {
                    d = val;
                } else if (typeof val === "string") {
                    // Handles "2025-09-13T07:46:54.000Z" and other ISO-ish strings
                    d = parseISO(val);
                } else {
                    d = new Date(val as any);
                }

                return isValid(d) ? format(d, "MM/dd/yyyy") : "";
            };
            
            const startStr = toMMDDYYYY(inputValues[`txtStartDateTime${index}`]);
            if (ValidateDOB({ dob: startStr })) {
              const parsedStart = parse(startStr, 'MM/dd/yyyy', new Date());
              if (isValid(parsedStart)) {
                start_date = parsedStart; // Date
              }
            }

            const endStr = toMMDDYYYY(inputValues[`txtEndDateTime${index}`]);
            if (ValidateDOB({ dob: endStr })) {
              const parsedEnd = parse(endStr, 'MM/dd/yyyy', new Date());
              if (isValid(parsedEnd)) {
                end_date = parsedEnd; // Date
              }
            }
            //End, Saber, 20260522, CHN-21544 - Per diem date validation hardening
            if (!isNullOrEmpty(start_date) && !isNullOrEmpty(end_date)) {
                // To calculate the time difference of two dates
                // Difference in milliseconds
                let Difference_In_Time = end_date.getTime() - start_date.getTime();

                if (Difference_In_Time == 0) {
                    same_date = 1;
                }

                // To calculate the no. of days between two dates
                num_of_days = (Difference_In_Time / (1000 * 3600 * 24)) + 1;

                //Prevent negative days
                if (num_of_days < 0) {
                    num_of_days = 0;
                    negative_date = 1;
                }

            }

            //Check invoice/receipt date value
            //Begin, Saber, 20260819 - Fall back to the per diem period dates (txtStartDateTime/txtEndDateTime)
            //when the invoice/receipt date fields (txtStartDate/txtEndDate) were not populated, since those
            //fields are only ever mirrored via the date-picker onChange and can remain empty even when the
            //per diem period dates are valid - this falsely blocked otherwise-valid per diem claims.
            let invoice_end_date = toMMDDYYYY(inputValues[`txtEndDate${index}`]) || endStr;
            let invoice_start_date = toMMDDYYYY(inputValues[`txtStartDate${index}`]) || startStr;
            //End, Saber, 20260819
            let invoice_final_start_date = new Date()
            let invoice_final_date = new Date()
            let start_control = 0
            if (invoice_end_date != '' && invoice_end_date != null && invoice_end_date != undefined) {
                if (ValidateDOB({ dob: invoice_end_date })) {
                    //invoice_final_date = convertToDate(invoice_end_date)
                    start_control = 1;
                } else {
                    myToast.warning(translate(`Invoice/receipt date must be entered.`));
                    formIsValid = false;
                }

            } else {
                myToast.warning(translate(`Invoice/receipt date must be entered.`));
                formIsValid = false;
            }


            if (invoice_start_date != '' && invoice_start_date != null && invoice_start_date != undefined) {
                if (ValidateDOB({ dob: invoice_start_date })) {
                    // invoice_final_start_date = convertToDate(invoice_start_date)
                    start_control = 1
                } else {
                    myToast.warning(translate(`Invoice/receipt date must be entered.`));
                    formIsValid = false;
                }

            } else {
                myToast.warning(translate(`Invoice/receipt date must be entered.`));
                formIsValid = false;
            }

            //Negative value date checking
            if (negative_date == 1) {
                formIsValid = false;
                if (objCreator.country_code == 'JP') {
                    myToast.warning(translate(`Date of first full day not greater than Date of last full day.`));
                } else {
                    myToast.warning(translate(`Date of first full day abroad not greater than Date of last full day abroad.`));
                }
            }
            //Begin, Saber, 20260522, CHN-21544 - Per diem same-date validation
            // Per diem requires a date range, so the start and end date cannot be the same day.
            //Saber, 20260810 - remove the checking - ECL-610
            /*if (same_date == 1) {
                formIsValid = false;
                if (objCreator.country_code == 'JP') {
                    myToast.warning(translate(`Date of first full day cannot be the same as Date of last full day.`));
                } else {
                    myToast.warning(translate(`Date of first full day abroad cannot be the same as Date of last full day abroad.`));
                }
            }*/
            //End, Saber, 20260522, CHN-21544 - Per diem same-date validation
            //CG-Hardship hide date checking
            if (objCreator.country_code == 'TH') {
                for (let a = 1; a <= appConfig.PerDiemColumn; a++) {
                    let location_text = inputValues[`txtPerDiemLocationSPR${a}_${index}_text`];
                    if (location_text != "") {
                        if (location_text == "CG-Hardship") {
                            let cgValue = inputValues[`txtPerDiem_NumberofDaysSPR${a}_${index}`];
                            num_of_days_allocated = num_of_days_allocated - cgValue;
                        } else {

                        }
                    }
                }
            }

            if (start_control == 1) {
                for (let a = 1; a <= num_per_diem_col; a++) {
                    if (document.querySelector<HTMLSelectElement>(`#txtPerDiem_NumberofDaysSPR${a}_${index}`)?.classList.contains("needValue")) {
                        let cur_location_text = inputValues[`txtPerDiemLocationSPR${a}_${index}_text`];
                        let cur_num_of_days_allocated = inputValues[`txtPerDiem_NumberofDaysSPR${a}_${index}`];

                        num_of_days_allocated = inputValues[`txtPerDiem_NumberofDaysSPR${a}_${index}`];
                        if (num_of_days_allocated > num_of_days) {
                            myToast.warning(translate(`Number of days allocated exceed the date range that you selected.`));
                            formIsValid = false;
                            break;
                        } else {
                            num_of_days_allocated = cur_num_of_days_allocated;
                            for(let l = 1; l <= num_per_diem_col; l++){
                                let location_text =inputValues[`txtPerDiemLocationSPR${l}_${index}_text`];

                                if(l != index && cur_location_text == location_text){
                                    num_of_days_allocated += inputValues[`txtPerDiem_NumberofDaysSPR${l}_${index}`];
                                }
                            }
                            if (num_of_days_allocated > num_of_days) {
                                myToast.warning(translate(`Number of days allocated exceed the date range that you selected.`));
                                formIsValid = false;
                                break;
                            }
                        }
                    } else {
                        break; //Break when there is no value is found
                    }
                }
            }

        }
    }

    //End of error message checking for per diem calculation

    // [#SR-380798] Hard Code the invoice date checking for SG Dental Claims 2024
    if (inputValues[`ddlCategory${index}`] == "22") {
        if (objRequestor.country_code == 'SG' && inputValues[`txtDate${index}`] > new Date(new Date('2023-12-31').setHours(0, 0, 0, 0))) {
            myToast.warning(translate(`You can only claim for dental claims invoiced prior to December 31, 2023`));
            formIsValid = false;
        }
    }

    // [#SR-436321] Hard Code invoice date checking for TH95 2024
    if (objRequestor.company_code == 'TH95' && inputValues[`txtDate${index}`] > new Date(new Date('2023-12-31').setHours(0, 0, 0, 0))) {
        myToast.warning(translate(`You can only claim for claims invoiced prior to December 31, 2023`));
        formIsValid = false;
    }

    //Personal Expense category - does not allow negative value
    if (inputValues[`ddlCategory${index}`] == "33") {
        if (inputValues[`txtClaimAmount${index}`] < 0) {
            myToast.warning(translate(`Personal expense category can not be used for negative value corpoarte credit item claim. Please choose other category to proceed.`));
            formIsValid = false;
        }
    }

    //Accomodation - Check-in date and check-out date
    let num_of_hotel_days = 0;
    num_of_hotel_days = inputValues[`txtNumNight${index}`]

    if (num_of_hotel_days <= 0 && num_of_hotel_days != undefined) {
        myToast.warning(translate(`Number of hotel nights cannot be zero. Please choose Check-in date and Check-out date again`));
        formIsValid = false;
    }


    // NOTE: Cost center validation is now handled in the comprehensive block below (near end of function).

    // VAT Section Validation Check

    if (inputValues[`ddlVAT${index}`] == 1) {
        if (inputValues[`ddlBusinessPlace${index}`] == null || inputValues[`ddlBusinessPlace${index}`] == undefined || inputValues[`ddlBusinessPlace${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Business Place column."));
            formIsValid = false;
        }


        if (inputValues[`txtCompName${index}`]== null || inputValues[`txtCompName${index}`]== undefined || inputValues[`txtCompName${index}`]== '') {
            myToast.warning(translate("Please_key_in_some_value_in_the_VAT_Company_Name_column"));
            formIsValid = false;
        }

        if (inputValues[`txtBaseAmount${index}`] == null || inputValues[`txtBaseAmount${index}`] == undefined || inputValues[`txtBaseAmount${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Base VAT column."));
            formIsValid = false;
        }

        if (inputValues[`txtVAtPercentage${index}`] == null || inputValues[`txtVAtPercentage${index}`] == undefined || inputValues[`txtVAtPercentage${index}`] == '') {
            myToast.warning(translate("Please key in some value in the VAT % column."));
            formIsValid = false;
        }

        if (inputValues[`txtHeadOffice${index}`] == null || inputValues[`txtHeadOffice${index}`] == undefined || inputValues[`txtHeadOffice${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Head Office/branch code column."));
            formIsValid = false;
        }

        if (inputValues[`txtBaseAmount${index}`] == null || inputValues[`txtBaseAmount${index}`] == undefined || inputValues[`txtBaseAmount${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Base VAT."));
            formIsValid = false;
        }

        if (inputValues[`txtHeadOffice${index}`].length < 5) {
            mandatoryInput(`#txtHeadOffice${index}`, true, "text");
            myToast.warning(translate("Head Office branch code field should have 5 characters."));
            formIsValid = false;
        }

        if (inputValues[`txtTaxId${index}`] == null || inputValues[`txtTaxId${index}`] == undefined || inputValues[`txtTaxId${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Tax Id column."));
            formIsValid = false;
        }

        if (inputValues[`txtTaxId${index}`].length < 13) {
            mandatoryInput(`#txtTaxId${index}`, true, "text");
            myToast.warning(translate("Tax id field should have 13 characters."));
            formIsValid = false;
        }


    }

    // WHT Section Validation Check

    if (inputValues[`ddlWHT${index}`] == 1) {
        if (inputValues[`txtWHTCompName${index}`] == null || inputValues[`txtWHTCompName${index}`] == undefined || inputValues[`txtWHTCompName${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Company Name column."));
            formIsValid = false;
        }
        if (inputValues[`txtWHTAmount${index}`] == null || inputValues[`txtWHTAmount${index}`] == undefined || inputValues[`txtWHTAmount${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Base WHT column."));
            formIsValid = false;
        }
        if (inputValues[`txtWHTPercentage${index}`] == null || inputValues[`txtWHTPercentage${index}`] == undefined || inputValues[`txtWHTPercentage${index}`] == '') {
            myToast.warning(translate("Please key in some value in the WHT Perc_column."));
            formIsValid = false;

        }
        if (isElementVisible(`#divWHT_BaseAmount2${index}`)) {
            if (inputValues[`txtWHTPercentage2${index}`]== null || inputValues[`txtWHTPercentage2${index}`]== undefined || inputValues[`txtWHTPercentage2${index}`]== '') {
                myToast.warning(translate("Please key in some value in the WHT Perc column."));
                formIsValid = false;
            }
        }

        if (inputValues[`txtHouseNumber${index}`] == null || inputValues[`txtHouseNumber${index}`] == undefined || inputValues[`txtHouseNumber${index}`] == '') {
            myToast.warning(translate("Please key in some value in the House number column."));
            formIsValid = false;
        }

        if (inputValues[`txtWHTCity${index}`] == null || inputValues[`txtWHTCity${index}`] == undefined || inputValues[`txtWHTCity${index}`] == '') {
            myToast.warning(translate("Please key in some value in the City column."));
            formIsValid = false;
        }

        if (inputValues[`txtPostCode${index}`]== null || inputValues[`txtPostCode${index}`]== undefined || inputValues[`txtPostCode${index}`]== '') {
            myToast.warning(translate("Please key in some value in the PostCode column."));
            formIsValid = false;
        }

        if (inputValues[`txtPostCode${index}`].length < 5) {
            mandatoryInput(`#txtPostCode${index}`, true, "text");
            myToast.warning(translate("Post Code field should have 5 characters."));
            formIsValid = false;
        }

        if (inputValues[`txtTaxNumber${index}`] == null || inputValues[`txtTaxNumber${index}`] == undefined || inputValues[`txtTaxNumber${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Tax number column."));
            formIsValid = false;
        }
        if (inputValues[`txtTaxNumber${index}`].length < 13) {
            mandatoryInput(`#txtTaxNumber${index}`, true, "text");
            myToast.warning(translate("Tax Number field should have 13 characters."));
            formIsValid = false;
        }

        if (inputValues[`txtWHTAmount${index}`] == null || inputValues[`txtWHTAmount${index}`] == undefined || inputValues[`txtWHTAmount${index}`] == '') {
            myToast.warning(translate("Please key in some value in the Base WHT."));
            formIsValid = false;
        }

        if (!isNullOrEmpty(inputValues[`ddlWHT2${index}`]) && inputValues[`ddlWHT2${index}`] == "1") {
            if (inputValues[`txtWHTAmount2${index}`] == null || inputValues[`txtWHTAmount2${index}`] == undefined || inputValues[`txtWHTAmount2${index}`] == '') {
                myToast.warning(translate("Please key in some value in the Base WHT2."));
                formIsValid = false;
            }
        }

        if (validateWHTPercentage(index,inputValues)) {
            myToast.warning(translate("WHT Type Percentage should not be same for both WHT and WHT2."));
            formIsValid = false;
        }

    }

    // Begin,Saber,20260922,ECL-713 - Invoice/Receipt Number: CN 25, all other markets 16. Mandatory when visible.
    // Duplicates are blocked only for TH; every other market allows them.
    const invoiceRule = getInvoiceFieldRule(objRequestor.country_code);
    const invoiceValue = inputValues[`txtInvoiceNum${index}`];
    const hasInvoiceValue = invoiceValue != null && invoiceValue != undefined && invoiceValue != '';
    if (isElementVisible(`#txtInvoiceNum${index}`)) {
        if (invoiceRule.mandatory && !hasInvoiceValue) {
            myToast.warning(translate("Please key in some value in the Invoice/Receipt Number column."));
            formIsValid = false;
        } else if (hasInvoiceValue && invoiceValue.length > invoiceRule.maxLength) {
            myToast.warning(translate(`Invoice/Receipt Number must not exceed ${invoiceRule.maxLength} characters.`));
            formIsValid = false;
        }
    }
    // End,Saber,20260922,ECL-713

    //Hard coded, need to be fixed soon
    if (objRequestor.country_code == "TH") {

        if ((inputValues[`ddlCategory${index}`] != "4" && inputValues[`ddlCategory${index}`] != "16") && inputValues[`ddlCategory${index}`] != "41" && inputValues[`ddlCategory${index}`] != "42" && inputValues[`ddlCategory${index}`] != "46" && inputValues[`ddlCategory${index}`] != "47" && inputValues[`ddlCategory${index}`] != "48") {
            if (inputValues[`ddlCategory${index}`] == "29" && inputValues[`ddlDetailType${index}`] == "5") {
                if (isElementVisible(`#txtInvoiceNum${index}`) && (inputValues[`txtInvoiceNum${index}`] == null || inputValues[`txtInvoiceNum${index}`] == undefined || inputValues[`txtInvoiceNum${index}`] == '')) {
                    //if ($('#ddlCurrency' + id_n).val() == 'THB') {
                        myToast.warning(translate("Please key in some value in the Invoice Number column."));
                        formIsValid = false;
                    //}
                }
            }
            else if (inputValues[`txtInvoiceNum${index}`] != null && inputValues[`txtInvoiceNum${index}`] != undefined && inputValues[`txtInvoiceNum${index}`] != '') {
                let re = /^([a-zA-Z0-9/-?:().,'+ -][^;{}|*&^%$@@#!\\<>~`_\[\]"\"]+)$/;
                if (!re.test(inputValues[`txtInvoiceNum${index}`])) {
                    myToast.warning(translate("Please key in valid sequence in the Invoice Number column."));
                    formIsValid = false;
                }

                if (inputValues[`txtInvoiceNum${index}`].charAt(0) == '-') {
                    myToast.warning(translate("Please key in valid first letter in the Invoice Number column."));
                    formIsValid = false;
                }
            }
            else if (inputValues[`ddlCategory${index}`] == "29" && inputValues[`ddlDetailType${index}`] != "5") {
                //do nothing
            }
            else if (isElementVisible(`#txtInvoiceNum${index}`) && (inputValues[`txtInvoiceNum${index}`] == null || inputValues[`txtInvoiceNum${index}`] == undefined || inputValues[`txtInvoiceNum${index}`] == '')) {
                //if ($('#ddlCurrency' + id_n).val() == 'THB') {
                    myToast.warning(translate("Please key in some value in the Invoice Number column."));
                    formIsValid = false;
                //}
            }
        }
    }

    // Begin, Saber, CHN-20860, Validate Receipt Number for MY (except MY98)
    if (objRequestor.country_code == "MY" && objRequestor.company_code != "MY98") {
        if (isElementVisible(`#txtInvoiceNum${index}`) && (inputValues[`txtInvoiceNum${index}`] == null || inputValues[`txtInvoiceNum${index}`] == undefined || inputValues[`txtInvoiceNum${index}`] == '')) {
            myToast.warning(translate("Please key in some value in the Receipt Number column."));
            formIsValid = false;
        }
        else if (inputValues[`txtInvoiceNum${index}`] != null && inputValues[`txtInvoiceNum${index}`] != undefined && inputValues[`txtInvoiceNum${index}`] != '') {
            let re = /^([a-zA-Z0-9/-?:().,'+ -][^;{}|*&^%$@@#!\\<>~`_\[\]"\"]+)$/;
            if (!re.test(inputValues[`txtInvoiceNum${index}`])) {
                myToast.warning(translate("Please key in valid sequence in the Receipt Number column."));
                formIsValid = false;
            }
            if (inputValues[`txtInvoiceNum${index}`].charAt(0) == '-') {
                myToast.warning(translate("Please key in valid first letter in the Receipt Number column."));
                formIsValid = false;
            }
            if (inputValues[`txtInvoiceNum${index}`].length > invoiceRule.maxLength) {
                myToast.warning(translate(`Receipt Number must not exceed ${invoiceRule.maxLength} characters.`));
                formIsValid = false;
            }
        }
    }
    // End, Saber, CHN-20860

    if (objRequestor.country_code == "TH" && inputValues[`ddlCategory${index}`] == "20") {

        let checkEmployeeChildrenAge = checkEmployeeChildrenEducation_Age(index, inputValues);
            if (!checkEmployeeChildrenAge) {
                myToast.warning(translate("Employee children age checking."));
                formIsValid = false;
                // return formIsValid;
            }
    }

    //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
    if (objRequestor.country_code == "DE" || objRequestor.country_code == "PL" || objRequestor.company_code == "CH87" || objRequestor.country_code == "VN") {

        if (inputValues[`hidValidate_CC_DE_Tax`] > 0) {
            myToast.warning(translate("Tax base amount add up should equal to invoice receipt amount."));
            formIsValid = false;
            // return formIsValid;

        }
    }



    //Error Message when normal user try to create calamity assistance for Thailand
    //subcategory 29 (Other employee benefits)
    //Detail type 4 (calamity assistance)
    if (objCreator.country_code == "TH" && inputValues[`ddlCategory${index}`] == "29" && inputValues[`ddlDetailType${index}`] == "4") {
        let temp_hrba_list = appConfig.THHRBAUSERLIST;
        let TH_HRBA_USER = temp_hrba_list.split(',')

        if (TH_HRBA_USER.indexOf(objCreator.personnel_number) < 0) {
            myToast.warning(translate("This feature is applicable for HR Benefits Administrators only."));
            formIsValid = false;
            // return formIsValid;
        }

    }

    //Validation Checking Service Order value

    if (isElementVisible(`#div_ServiceOrder${index}`)) { //check element division existence
        if (isElementVisible(`#ddlSO2_${index}`)  || !isNullOrEmpty(inputValues[`ddlSO2_${index}`])) { //Check input is being filled by value

            //Pecentage amount or total amount checking
            let SOtype = ''
            //Radio button
            if (inputValues[`#rdServiceOrderType${index}`] == "percentage" ) {
                SOtype = 'percentage';
            } else {
                SOtype = 'amount';
            }

            if (SOtype == 'percentage') {
                let total_percentage = 0.00;

                for (let a = 1; a <= 5; a++) {
                    if (isElementVisible(`#divSO${a}_${index}`)) {
                        total_percentage += parseFloat(inputValues[`txtSOPercent${a}_${index}`]?.toString() ?? "0");
                    } else {
                        break;
                    }
                }

                if (total_percentage != 100) {
                    myToast.warning(translate("The total percentage of service order must equal to 100."));
                    formIsValid = false;
                    // return formIsValid;
                }
                } else if (SOtype == 'amount') {
                    let total_amount = 0.00;

                    for (let a = 1; a <= 5; a++) {
                        if (isElementVisible(`#divSO${a}_${index}`)) {
                            total_amount += parseFloat(inputValues[`txtSOPercent${a}_${index}`]?.toString() ?? "0");
                        } else {
                            break;
                        }
                    }

                    //let final_amount = 0.00

                    //if (inputValues[`ddlVAT${index}`] == '1') {
                    //    final_amount = parseFloat(inputValues[`txtClaimAmount${index}`]) - parseFloat(inputValues[`hidden_VAT_Amount${index}`])
                    //} else {
                    //    final_amount = parseFloat(inputValues[`txtClaimAmount${index}`])
                    //}

                    let finalAmount2 = 0.00;

                    if (inputValues[`ddlVAT${index}`] == '1') {
                        finalAmount2 = parseFloat(inputValues[`hidden_Init_claim_Amount${index}`]?.toString() ?? "0") - parseFloat(inputValues[`hidden_VAT_Amount${index}`]?.toString() ?? "0");
                    }
                    else {
                        if ($('#hidden_Init_claim_Amount' + index) && typeof inputValues[`hidden_Init_claim_Amount${index}`] !== 'undefined') {
                            finalAmount2 = parseFloat(inputValues[`hidden_Init_claim_Amount${index}`]?.toString() ?? "0");
                        }
                        else {
                            finalAmount2 = inputValues[`txtClaimAmount${index}`];
                        }
                    }

                    if (total_amount.toFixed(number_of_decimal) != finalAmount2.toFixed(number_of_decimal)) {
                        myToast.warning(translate("The total amount of service order must equal to invoice/receipt amount."));
                        formIsValid = false;
                        // return formIsValid;
                    }
                }

            //Duplication checking
            let SOlist = [];
            for (let a = 1; a <= 5; a++) {
                if (isElementVisible(`#divSO${a}_${index}`)) {
                    SOlist.push(inputValues[`divSO${a}_${index}`]);
                } else {
                    break;
                }
            }
            if (checkForDuplicates(SOlist)) {
                myToast.warning(translate("Service order code cannot be duplicate."));
                formIsValid = false;
                // return formIsValid;
            }

            //Check correct service order master list
            for (let a = 1; a <= 5; a++) {
                if (!isNullOrEmpty(inputValues[`ddlSO${a}_${index}`])) {
                    if (bindDDL?.[`soDDL`]?.length) {
                        if (bindDDL?.[`soDDL`]?.length > 0) {
                            if (!isNullOrEmpty(inputValues[`ddlSO${a}_${index}`])) {
                                let obj = bindDDL?.[`soDDL`]?.filter((option: any) => option.value == inputValues[`ddlSO${a}_${index}`]);
            
                                if (obj != null && obj.length > 0) {
                                    elementDisplay(`.ddlSO${a}_${index}-invalid-feedback`, false, "div");
                                }
                                //else if (objRequestor.company_code.startsWith('PT') && $("#ddlinternal_order" + id_n).val()!='') {
            
                                //    $("#ddlinternal_order" + id_n).removeClass('is-invalid');
            
            
                                //}
                                else if (document.querySelector<HTMLSelectElement>(`#ddlSO${a}_${index}`)?.classList.contains(`select-ddl-required`)) {
                                    elementDisplay(`.ddlSO${a}_${index}-invalid-feedback`, true, "div");
                                    formIsValid = false;
                                    // return formIsValid;
                                }
                            }
                        } else if (document.querySelector<HTMLSelectElement>(`#ddlSO${a}_${index}`)?.classList.contains(`select-ddl-required`)) {
                            elementDisplay(`.ddlSO${a}_${index}-invalid-feedback`, true, "div");
                            formIsValid = false;
                            // return formIsValid;
                        }
                    }
                }
            }



        }
    }


    if (isElementVisible(`#divProjectCode_${index}`)) { //Check the element is not being hidden
        //Hazel Amendments 20260105  isElementVisible(`#txtProjectCode2_${index}`) ->  isElementVisible(`#divPC2_1`) , cuz txtProjectCode2_${index} will always display , no special hidden logic for it 
        //#SR-866915 project code validation keep popping
        if (!isNullOrEmpty(inputValues[`txtProjectCode1_${index}`]) || isElementVisible(`#divPC2_1`)) { 
            let total_percentage = 0.00;

            for (let a = 1; a <= 20; a++) {
                if (isElementVisible(`#divPC${a}_${index}`)) {
                    total_percentage += parseFloat(inputValues[`txtPCPercent${a}_${index}`]?.toString() ?? "0")

                    if (parseFloat(inputValues[`txtPCPercent${a}_${index}`]?.toString() ?? "0") < 0) {
                        myToast.warning(translate("Project Code percentage cannot have negative."));
                        formIsValid = false;
                        // return formIsValid;
                    }

                } else {
                    break;
                }
            }

            if (total_percentage != 100) {
                myToast.warning(translate("Project Code percentage does not equal 100."));
                formIsValid = false;
                // return formIsValid;
            }

            //Duplication checking
            let PClist = [];
            for (let a = 1; a <= 20; a++) {
                if (isElementVisible(`#divPC${a}_${index}`)) {
                    PClist.push(inputValues[`txtProjectCode${a}_${index}`]);
                } else {
                    break;
                }
            }
            if (checkForDuplicates(PClist)) {
                myToast.warning(translate("Project Code has duplicates."));
                formIsValid = false;
                // return formIsValid;
            }

            for (let a = 1; a <= 20; a++) {
                if (!isNullOrEmpty(inputValues[`txtProjectCode${a}_${index}`])) {
                    if (bindDDL?.[`wbsProjectCodeDDL`]?.length) {
                        if (bindDDL?.[`wbsProjectCodeDDL`]?.length > 0) {
                            if (!isNullOrEmpty(inputValues[`txtProjectCode${a}_${index}`])) {
                                let obj = bindDDL?.[`wbsProjectCodeDDL`]?.filter((option: any) => option.value == inputValues[`txtProjectCode${a}_${index}`]);
            
                                if (obj != null && obj.length > 0) {
                                    elementDisplay(`.txtProjectCode${a}_${index}-invalid-feedback`, false, "div");
                                }
    
                                else if (document.querySelector<HTMLSelectElement>(`#txtProjectCode${a}_${index}`)?.classList.contains(`select-ddl-required`)) {
                                    elementDisplay(`.txtProjectCode${a}_${index}-invalid-feedback`, true, "div");
                                    formIsValid = false;
                                    // return formIsValid;
                                }
                            }
                        } else if (document.querySelector<HTMLSelectElement>(`#txtProjectCode${a}_${index}`)?.classList.contains(`select-ddl-required`)) {
                            myToast.warning(translate("Project Code entered is invalid."));
                            elementDisplay(`.txtProjectCode${a}_${index}-invalid-feedback`, true, "div");
                            formIsValid = false;
                            // return formIsValid;
                        }
                    }
                }
            }


        }
    }


    if (isElementVisible(`#divProjectCode_${index}`)) {
        if (isElementVisible(`#divCostCenter${index}`) && isElementVisible(`#ddlCC1_${index}`) && !isNullOrEmpty(inputValues[`ddlCC1_${index}`]) && !isNullOrEmpty(inputValues[`txtPCPercent1_${index}`])) {
            myToast.warning(translate("Please do not enter cost center when there is project code."));
            formIsValid = false;
            // return formIsValid;
        } else {
            //ClearCostCenter(id_n);
            //resetAPevent(id_n);
        }
    }

    if (isElementVisible(`#div_ServiceOrder${index}`)) {

        if (isElementVisible(`#divCostCenter${index}`) && isElementVisible(`#ddlCC1_${index}`) && !isNullOrEmpty(inputValues[`ddlCC1_${index}`]) && !isNullOrEmpty(inputValues[`txtSOPercent1_${index}`])) {
            myToast.warning(translate("Please do not enter cost center when there is service order."));
            formIsValid = false;
            // return formIsValid;
        }
    }

    // SG Wellness Flex field check
    if (isElementVisible(`#ddlWellnessType${index}`)) {
        if (isNullOrEmpty(inputValues[`ddlWellnessType${index}`])) {
            formIsValid = false;
        }
    }
    //HAZEL AMENDMENTS 20260724 - CHN-22431 [TH] Add PDP Related Educational Subcategory under Flexible Benefits
    if (isElementVisible(`#TrainingDate${index}`)) {
        const trainingDateValue = inputValues[`txtTrainingDate${index}`];

        if (isNullOrEmpty(trainingDateValue)) {
            formIsValid = false;
        } else {
            const trainingDate = trainingDateValue instanceof Date
                ? trainingDateValue
                : parse(trainingDateValue.toString(), "dd/MM/yyyy", new Date());
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (!isValid(trainingDate)) {
                formIsValid = false;
            } else {
                const trainingDateOnly = new Date(trainingDate);
                trainingDateOnly.setHours(0, 0, 0, 0);
                if (trainingDateOnly > today) {
                    formIsValid = false;
                }
            }
        }
    }


    //Terk Amendment 20230712 : SG Wellness Flex Currency Field Validation check
    //Terk Amendment 20240220 [#CHN-984]: SG Wellness Flex Currency Field Validation check (Remove for CR CHN-984)
    //if (objRequestor.country_code == "SG" && $("#ddlCategory"+ id_n).val() == "50"  &&  $("#ddlCurrency"+ id_n).val() != "SGD") {
    //    //$("#sg-wellness-currency-errmsg").show();
    //    toastr.error("Only SGD Currency is allowed in SG Wellness Flexi Claim.");
    //    isValid = false;
    //}

    //Terk Amendment 20240220 [#CHN-984]: SG Wellness Flex Dental block Dental receipt before  1/1/2024
    if (objRequestor.country_code == "SG" && inputValues[`ddlCategory${index}`] == "50" && inputValues[`ddlWellnessType${index}`] == "7") {
        //$("#sg-wellness-currency-errmsg").show();
        if (inputValues[`txtDate${index}`] < new Date(new Date('2024-01-01').setHours(0, 0, 0, 0))) {
            myToast.warning(translate("You are not allowed to submit dental expenses under wellness flex before Jan 1, 2024. Kindly check with the local HR for further information."));
            formIsValid = false;
            // return formIsValid;
        }

        if (inputValues[`chkWellnessDentalDisclaimer_${index}`] == "0") {
            myToast.warning(translate("Please tick on the disclaimer checkbox before submitting the dental claim under Wellness Flex."));
            formIsValid = false;
            // return formIsValid;
        }

    }

    //Terk Amendment 20240312 [#CHN-9651]: PH expense nature validation checking for PH with category 28,29,45.
    if (objRequestor.country_code == "PH" && (inputValues[`ddlCategory${index}`]== '28' || inputValues[`ddlCategory${index}`]== '29' || inputValues[`ddlCategory${index}`]== '45')) {
        // if (!isNullOrEmpty(`rdExpenseNature${index}`)) {
        //     myToast.warning(translate("Please select expense nature before submitting the claim."));
        //     formIsValid = false;
        //     // return formIsValid;
        // }

        if (isNullOrEmpty(inputValues[`rdExpenseNature${index}`])) {
            myToast.warning(translate("Please select expense nature before submitting the claim."));
            formIsValid = false; //saber,20251013, revised the validation checking condition
        }

    }

    //Costcenter code and its percentage checking
    //check for all cost center field which is being filled with value
    if (isElementVisible(`#divCostCenter${index}`)) {
        let ccTotalPercent = 0;
        let hasAnyCostCenter = false;
        let ccPairValid = true;
        const filledCodes: string[] = [];

        // First pass: find the last row that has any data (code or percentage)
        // A row with no code and percentage = 0 is treated as empty
        let lastFilledRow = -1;
        for (let a = 0; a < 20; a++) {
            const suffix = index + a;
            if (!isElementVisible(`#cc1_${suffix}`)) break;
            const hasCode = !isNullOrEmpty(inputValues[`ddlCC1_${suffix}`]);
            const percVal = inputValues[`txtCCPercent1_${suffix}`];
            const hasPerc = !isNullOrEmpty(percVal) && percVal !== "" && !(parseFloat(percVal) === 0 && !hasCode);
            if (hasCode || hasPerc) lastFilledRow = a;
        }

        // Second pass: validate rows 0 through lastFilledRow (no gaps allowed)
        for (let a = 0; a <= lastFilledRow; a++) {
            const suffix = index + a;
            const codeKey = `ddlCC1_${suffix}`;
            const percKey = `txtCCPercent1_${suffix}`;

            if (!isElementVisible(`#cc1_${suffix}`)) break;

            const hasCode = !isNullOrEmpty(inputValues[codeKey]);
            const percVal = inputValues[percKey];
            // No code + percentage 0 = treat as empty row
            const hasPerc = !isNullOrEmpty(percVal) && percVal !== "" && !(parseFloat(percVal) === 0 && !hasCode);

            hasAnyCostCenter = true;

            if (!hasCode && !hasPerc) {
                // Gap row — both empty in the middle of filled rows
                myToast.warning(translate("Cost Center row cannot be empty. Please fill in or remove the empty row."));
                ccPairValid = false;
            } else if (hasCode && !hasPerc) {
                myToast.warning(translate("Cost Center percentage should be between 1 and 100."));
                ccPairValid = false;
            } else if (!hasCode && hasPerc) {
                myToast.warning(translate("Cost Center code should not be empty when percentage is filled."));
                ccPairValid = false;
            } else {
                // both filled — check for duplicate code
                const codeVal = inputValues[codeKey].toString();
                if (filledCodes.includes(codeVal)) {
                    myToast.warning(translate("Duplicate Cost Center is not allowed. Please select a different Cost Center."));
                    ccPairValid = false;
                } else {
                    filledCodes.push(codeVal);
                }

                // validate percentage range and accumulate
                const percNum = parseFloat(inputValues[percKey]);
                if (isNaN(percNum) || percNum <= 0 || percNum > 100) {
                    myToast.warning(translate("Cost Center percentage should be between 1 and 100."));
                    ccPairValid = false;
                } else {
                    ccTotalPercent += percNum;
                }
            }
        }

        if (!ccPairValid) {
            formIsValid = false;
        }

        if (hasAnyCostCenter && ccPairValid && Math.abs(ccTotalPercent - 100) > 0.01) {
            myToast.warning(translate("Cost Center total percentage must equal 100%."));
            formIsValid = false;
        }
    }

    if(validateClaimAmount(index!, inputValues, handleInputChange, inputValues[`txtClaimAmount${index}`]) == false){
        formIsValid = false;
    }

    // Begin,Saber,20261007,INC-1016292 - recheck the receipt bypass with the current amount before
    // showing the attachment error. Transport > Public transport, JPY 3000 or less, is not required.
    const allowZeroAttach = checkAndAllowZeroAttach(index, inputValues, handleInputChange);
    // End,Saber,20261007,INC-1016292

    if (allowZeroAttach == 0) {
        let objRequestor = getObjectRequester();
        const attachedDOc = document.querySelector<HTMLElement>('.upload-item-detail-sucessful');
        if(isNullOrEmpty(attachedDOc)) {
            if(objRequestor.country_code == "MM" && inputValues[`ddlCategory${index}`] == 48){
                formIsValid = false;
                myToast.warning(translate("Please upload cash or bank receipt"));
            }else{
                formIsValid = false;
                myToast.warning(translate("Please upload at least one attachment."));
            }
        }
    }

    if (inputValues[`ddlCategory${index}`] == 29) {
        let selectedText = bindDDL?.[`detailTypeDDL`]?.find((option: any) => option.value.toString() == inputValues[`ddlDetailType${index}`])?.label;
        if (!isNullOrEmpty(selectedText) && selectedText.replace(/'/g, "") == "Death benefit for staffs family") { //Terk Amendment 20250624 #SR-752550 // //Terk Amendment 20250624 #SR-804750
            if(isNullOrEmpty(inputValues[`txtIdofDeceasedPerson${index}`])){
                formIsValid = false;
                myToast.warning(translate("Please enter value for Id of Deceased Person."));
            }
        }
    }




    return formIsValid;
};




